import 'babel-polyfill';
import 'object-assign';
import React from 'react';
import ReactDOM from 'react-dom';
import Routes from './router/Routes';
import registerServiceWorker from './registerServiceWorker';
require('es6-promise').polyfill();
require('isomorphic-fetch');
require("jspolyfill-array.prototype.find");


ReactDOM.render(<Routes />, document.getElementById('root'));
registerServiceWorker();


// WEBPACK FOOTER //
// ./src/dashboards_redux/index.jsx